import { useEffect, useState } from "react";
import { clearStorage, getIsUserLinked } from "@utils/storage";
import { useLinkProspect } from "./useLinkProspect";
import { useHistory } from "react-router-dom";
import { keycloakUtils } from "itsf-ui-common";
import { addUserEmailHashToGTM } from "@utils/user";

export const useKeycloak = () => {
    const [isKeycloakLoading, setIsKeycloakLoading] = useState(true);
    const {
        linkProspect,
        linkProspectUserState,
        createProspectState,
        displayChangedInfoModal,
        setDisplayChangedInfoModal,
    } = useLinkProspect();

    const { push } = useHistory();

    useEffect(() => {
        const isLinked = getIsUserLinked();

        if (global.Keycloak) {
            keycloakUtils.init("check-sso", {
                checkLoginIframe: process.env.NODE_ENV !== "development",
            });

            keycloakUtils.setOnAuthSuccess(async () => {
                linkProspect()
                    .then(() => setIsKeycloakLoading(false))
                    .catch(() => setIsKeycloakLoading(false));
                await addUserEmailHashToGTM();
            });

            keycloakUtils.setOnAuthLogout(() => {
                clearStorage();
                push("/");
            });

            keycloakUtils.setOnReady(() => {
                if (!keycloakUtils.isAuthenticated() && isLinked) {
                    clearStorage();
                }
                if (!keycloakUtils.isAuthenticated()) {
                    setIsKeycloakLoading(false);
                }
            });

            keycloakUtils.setOnAuthError(() => {
                setIsKeycloakLoading(false);
            });
        } else {
            setIsKeycloakLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const linkProspectIfConnected = () => {
        if (keycloakUtils.isAuthenticated()) {
            linkProspect();
        }
    };

    const globalLoading = linkProspectUserState.isLoading || createProspectState.isLoading || isKeycloakLoading;
    const globalError = linkProspectUserState.error ?? createProspectState.error;

    return {
        displayChangedInfoModal,
        globalError,
        globalLoading,
        linkProspectIfConnected,
        setDisplayChangedInfoModal,
    };
};
